/* SWICH · ficha de producto: botones "Comprar" que agregan al carrito + barra fija inferior */
(function () {
  /* Botones "Comprar" de la ficha: agregan al carrito la variante elegida */
  function initBuy() {
    var submit = document.querySelector('.product__info-container .product-form__submit');
    if (!submit) return;
    var handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
    document.querySelectorAll('a.ap-btn').forEach(function (a) {
      if (a.__apBuy) return;
      var href = a.getAttribute('href') || '';
      if (!handle || href.indexOf('/products/' + handle) === -1) return;
      a.__apBuy = true;
      a.addEventListener('click', function (e) {
        var btn = document.querySelector('.product__info-container .product-form__submit');
        if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        btn.click();
      });
    });
  }

  /* Barra fija inferior de compra: miniatura, precio y botón (aparece al bajar) */
  function initSticky() {
    var info = document.querySelector('.product__info-container');
    var submit = info && info.querySelector('.product-form__submit');
    if (!submit || document.querySelector('.ap-sticky')) return;
    var bar = document.createElement('div');
    bar.className = 'ap-sticky'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Compra rápida');
    bar.innerHTML = '<div class="ap-sticky__in"><img class="ap-sticky__img" alt="" width="52" height="52">' +
      '<div class="ap-sticky__info"><b class="ap-sticky__title"></b><span class="ap-sticky__price"></span></div>' +
      '<button type="button" class="ap-sticky__btn">Agregar al carrito</button></div>';
    document.body.appendChild(bar);
    document.body.classList.add('ap-has-sticky');
    var img = bar.querySelector('.ap-sticky__img'), t = bar.querySelector('.ap-sticky__title'),
        p = bar.querySelector('.ap-sticky__price'), b = bar.querySelector('.ap-sticky__btn');
    function sync() {
      var m = document.querySelector('.product__media-item:not(.ap-vhide) img');
      if (m) {
        var s = m.currentSrc || m.src;
        try { var u = new URL(s, location.href); u.searchParams.set('width', '160'); u.searchParams.delete('height'); s = u.toString(); } catch (e) {}
        if (img.getAttribute('src') !== s) img.setAttribute('src', s);
      }
      var ti = info.querySelector('.product__title');
      t.textContent = ti ? ti.textContent.trim() : document.title;
      var pr = info.querySelector('.price .price-item--last') || info.querySelector('.price .price-item');
      p.textContent = pr ? pr.textContent.trim() : '';
      var off = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      b.disabled = off; b.textContent = off ? 'Agotado' : 'Agregar al carrito';
    }
    b.addEventListener('click', function () { if (!b.disabled) submit.click(); });
    function onScroll() {
      var r = submit.getBoundingClientRect();
      var nearEnd = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 40);
      var on = r.bottom < 0 && !nearEnd;
      if (on) sync();
      bar.classList.toggle('is-on', on);
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });
    window.addEventListener('resize', onScroll);
    sync(); onScroll();
  }

  /* Galería móvil: el carrusel toma el alto de la foto visible (sin espacio vacío) */
  function initGalleryHeight() {
    var list = document.querySelector('.product__media-list.slider');
    if (!list || list.__apH) return;
    list.__apH = true;
    var mq = window.matchMedia('(max-width: 749px)');
    var raf = 0;
    function fit() {
      raf = 0;
      if (!mq.matches) { list.style.height = ''; return; }
      var slides = list.querySelectorAll('.product__media-item');
      var left = list.getBoundingClientRect().left;
      var best = null, dist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        if (!slides[i].offsetWidth) continue;
        var d = Math.abs(slides[i].getBoundingClientRect().left - left);
        if (d < dist) { dist = d; best = slides[i]; }
      }
      if (best) list.style.height = best.offsetHeight + 'px';
    }
    function queue() { if (!raf) raf = requestAnimationFrame(fit); }
    window.__apFitGallery = queue;
    list.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (mq.addEventListener) mq.addEventListener('change', queue);
    list.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', queue); });
    fit();
  }

  /* Nombre de la opción de variante: "Color" en vez del nombre interno */
  function fixVariantLabel() {
    document.querySelectorAll('.product__info-container .form__label, .product__info-container legend').forEach(function (l) {
      if (/^\s*Variante Shopify\s*$/i.test(l.textContent)) l.textContent = 'Color';
    });
  }

  /* Galería por color: al elegir Negro o Blanco se ven solo las fotos de ese color.
     Una foto es de un color si su texto alternativo es ese color o si es la foto
     principal de esa variante. Las fotos sin color (p. ej. videos) se ven siempre. */
  var colorMap = null, colorNames = [];
  function loadColors() {
    if (colorMap || loadColors.busy) return;
    var handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
    if (!handle) return;
    loadColors.busy = true;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var map = {}, names = {};
        (p.variants || []).forEach(function (v) {
          var c = (v.option1 || '').trim().toLowerCase();
          if (c) names[c] = true;
          if (v.featured_media && c) map[v.featured_media.id] = c;
        });
        (p.media || []).forEach(function (m) {
          var a = (m.alt || '').trim().toLowerCase();
          if (names[a] && !map[m.id]) map[m.id] = a;
        });
        colorNames = Object.keys(names);
        colorMap = map;
        filterByColor();
      })
      .catch(function () {});
  }
  function selectedColor() {
    var checked = document.querySelector('.product__info-container variant-selects input:checked, .product__info-container variant-radios input:checked');
    if (checked) return checked.value.trim().toLowerCase();
    var sel = document.querySelector('.product__info-container variant-selects select');
    return sel ? sel.value.trim().toLowerCase() : '';
  }
  function filterByColor() {
    if (!colorMap || colorNames.length < 2) return;
    var color = selectedColor();
    if (colorNames.indexOf(color) === -1) return;
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var changed = false;
    list.querySelectorAll('.product__media-item').forEach(function (li) {
      var id = (li.getAttribute('data-media-id') || '').split('-').pop();
      var c = colorMap[id];
      var hide = !!c && c !== color;
      if (li.classList.contains('ap-vhide') !== hide) { li.classList.toggle('ap-vhide', hide); changed = true; }
    });
    if (!changed) return;
    var slider = list.closest('slider-component');
    if (slider && slider.resetPages) { try { slider.resetPages(); } catch (e) {} }
    /* El tema calcula la posición de la foto antes de ocultar las otras: volver al inicio del color */
    function toStart() {
      if (list.scrollLeft) list.scrollTo({ left: 0, behavior: 'auto' });
      if (slider && slider.update) { try { slider.update(); } catch (e) {} }
      if (window.__apFitGallery) window.__apFitGallery();
    }
    toStart(); setTimeout(toStart, 120); setTimeout(toStart, 600);
  }
  function initColorGallery() {
    var gallery = document.querySelector('.product__media-wrapper');
    if (!gallery || gallery.__apColor) return;
    gallery.__apColor = true;
    loadColors();
    var pending = 0;
    new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = 0; filterByColor(); });
    }).observe(gallery, { childList: true, subtree: true });
  }

  function init() { initBuy(); initSticky(); initGalleryHeight(); fixVariantLabel(); initColorGallery(); }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) { filterByColor(); setTimeout(fixVariantLabel, 400); setTimeout(fixVariantLabel, 1200); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
